import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyA2SxQPO3vvPubByUWWYg6LC1fgCr07-9Q",
  authDomain: "shiftai-76444.firebaseapp.com",
  databaseURL: "https://shiftai-76444-default-rtdb.firebaseio.com",
  projectId: "shiftai-76444",
  storageBucket: "shiftai-76444.appspot.com",
  messagingSenderId: "45017514530",
  appId: "1:45017514530:web:7ba37a76e83584d554007b",
  measurementId: "G-PV4944TXEF"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const database = getDatabase(app);

export { app, analytics, database };
